import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {polyfill as smoothScrollPolyFill} from 'smoothscroll-polyfill'; // Polyfill required for Safari and iOS.

@Component({
    standalone: false,
    selector: 'core-block-anchor-link',
    templateUrl: './block-anchor-link.component.html',
})

export class BlockAnchorLinkComponent extends BlockAbstractComponent implements OnInit {

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService
    ) {
        super(
            parser,
            auth
        );
        smoothScrollPolyFill();
    }

    scrollTo(target: string) {
        const element = document.getElementById(target);
        if (element) {
            const headerOffset = 20;
            const elementPosition = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
            const offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                behavior: 'smooth',
                top: offsetPosition
            });
        }
    }
}
